import { withForm } from '@/components/form';
import { SectionCard } from '@/components/ui';

import type { AchievementFormItem } from '../../contactSchema';
import { defaultFormValues } from '../../contactSchema';
import { AddItemButton, RepeaterItem } from './RepeaterItem';

const empty = (): AchievementFormItem => ({ type: '', title: '' });

export const AchievementsSection = withForm({
  defaultValues: defaultFormValues,
  render: function AchievementsSection({ form }) {
    return (
      <SectionCard
        title="Achievements & publications"
        actions={<AddItemButton onClick={() => form.pushFieldValue('achievements', empty())} />}
      >
        <form.AppField name="achievements">
          {(field) => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {(field.state.value ?? []).map((_, i) => (
                <RepeaterItem key={i} onRemove={() => field.removeValue(i)} removeLabel="Remove achievement">
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <div className="ds-form-grid-3">
                      <form.AppField name={`achievements[${i}].type`}>
                        {(f) => <f.TextField label="Type" required placeholder="publication, award…" />}
                      </form.AppField>
                      <form.AppField name={`achievements[${i}].date`}>
                        {(f) => <f.DatePicker label="Date" />}
                      </form.AppField>
                      <form.AppField name={`achievements[${i}].url`}>
                        {(f) => <f.TextField label="URL" placeholder="https://..." />}
                      </form.AppField>
                    </div>
                    <form.AppField name={`achievements[${i}].title`}>
                      {(f) => <f.TextField label="Title" required />}
                    </form.AppField>
                    <form.AppField name={`achievements[${i}].description`}>
                      {(f) => <f.TextField label="Description" multiline rows={2} />}
                    </form.AppField>
                  </div>
                </RepeaterItem>
              ))}
            </div>
          )}
        </form.AppField>
      </SectionCard>
    );
  },
});
